import { Fragment, useEffect, useState } from 'react';

const AssessmentExamQuestion = ({ index, input, changeHandler }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(undefined);
  const [isConfident, setIsConfident] = useState(false);

  useEffect(() => {
    if (!input) return;

    const answered = input.options.find((o) => o.isAnswer);
    setSelectedAnswer(answered?.id);
    setIsConfident(!!input.isConfident);
  }, [input]);

  if (!input) return null;

  return (
    <Fragment>
      <hr className="my-5" />

      <div className="px-4">
        <label className="block font-medium text-sky-700">
          {index + 1}. {input.question}
        </label>
      </div>

      <hr className="my-5" />

      {input.options.map((o) => (
        <div key={o.id} className="px-4 py-2">
          <label className="flex items-center gap-3 cursor-pointer dark:text-slate-300">
            <input
              type="checkbox"
              checked={selectedAnswer === o.id}
              onChange={() => {
                setSelectedAnswer(o.id);
                changeHandler(input.id, o.id, isConfident);
              }}
              className="w-5 h-5"
            />
            {o.option}
          </label>
        </div>
      ))}

      <div className="flex justify-end px-4 mt-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={isConfident}
            onChange={(e) => {
              setIsConfident(e.target.checked);
         changeHandler(
  input.id,
  selectedAnswer,
  e.target.checked
);
            }}
            className="w-5 h-5"
          />
          <span className="dark:text-slate-300">Confident?</span>
        </label>
      </div>

      <hr className="my-5" />
    </Fragment>
  );
};

export default AssessmentExamQuestion;
